const $$splitComponentImporter = () => import('/home/dylan/code/helldivers2-classes/packages/web/src/client/routes/classes.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/classes")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});